<template>
  <div>
    <dashboard-proponente v-if="this.tipoEmpresaSelecionada == 'Proponente'" />
    <dashboard-executora v-if="this.tipoEmpresaSelecionada == 'Executora'" />
  </div>
</template>

<script>
import DashboardExecutora from "./DashboardExecutora";
import DashboardProponente from "./DashboardProponente";
import { REGERAR_TOKEN_POR_EMPRESA } from "@/store/autenticacao.module";

export default {
  components: {
    DashboardProponente,
    DashboardExecutora,
  },
  data() {
    return {
      tipoEmpresaSelecionada: null,
    };
  },
  computed: {
    role: function () {
      return this.$store.state.app.user.role;
    },
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;

      return this.$store.state.app.selectedCompanyObj.tipo;
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
  },
  watch: {
    empresasSelecionada: {
      handler() {
        if (this.empresasSelecionada) {
          const self = this;
          const form = { tipoEmpresa: this.empresasSelecionada };
          this.$store
            .dispatch(REGERAR_TOKEN_POR_EMPRESA, form)
            .then(async () => {
              await this.$store.dispatch("app/fetchUserData");
              self.tipoEmpresaSelecionada = form.tipoEmpresa;
            })
            .catch(() => {
              this.alertaErro("Erro ao recarregar dashboard!");
            });
        }
      },
      immediate: true,
    },
    ehAdmin: function () {
      if (!this.empresasSelecionada && this.ehAdmin) {
        this.$router.push({ name: "dashboard-admin" });
      }
    },
  },
};
</script>
<style lang="">
</style>